export default {
  methods: {
    getAlertImage (data, type) {
      let date = ''
      let priority = ''
      if (type === 'invoice') {
        const removeDays = data.split('Days').join('')
        date = parseInt(removeDays)
      } else {
        priority = data
      }

      if (date < 7 || priority === 'HIGH') {
        return require('@/assets/image/icon/dashboard-red-alert.svg')
      } else {
        return require('@/assets/image/icon/dashboard-yellow-alert.svg')
      }
    },
    getIconMessage (type) {
      let imageSource = ''
      switch (type) {
        case 'NEW_MESSAGE' :
        case 'NEW_MESSAGE_SHIPMENT' :
        case 'NEW_MESSAGE_CONTRACT' :
        case 'NEW_MESSAGE_RFQ' :
          imageSource = require('@/assets/image/icon/message.svg')
          break
        case 'PAYMENT' :
          imageSource = require('@/assets/image/icon/receipt.svg')
          break
        case 'NEW_BID_RFQ' :
        case 'NEW_BID_CONTRACT' :
          imageSource = require('@/assets/image/icon/submited.svg')
          break
        case 'NEW_SHIPMENT_DELAY_DESTINATION_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_DELAY_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_DELAY_PICKUP' :
        case 'NEW_SHIPMENT_DELAY_DELIVERY' :
        case 'NEW_SHIPMENT_DELAY_DEPARTURE' :
        case 'NEW_SHIPMENT_DELAY_SCHEDULED' :
        case 'NEW_SHIPMENT_DELAY_ARRIVAL' :
          imageSource = require('@/assets/image/icon/notif-delay.svg')
          break
        case 'NEW_RFQ_VALIDATING_REJECTED' :
        case 'NEW_CONTRACT_VALIDATING_REJECTED' :
        case 'NEW_SHIPMENT_REJECTED' :
        case 'NEW_SHIPMENT_CANCELED' :
          imageSource = require('@/assets/image/icon/dashboard-rejected.svg')
          break
        case 'NEW_RFQ_VALIDATING' :
        case 'NEW_CONTRACT_VALIDATING' :
          imageSource = require('@/assets/image/icon/checking.svg')
          break
        case 'NEW_CONTRACT_ONGOING' :
          imageSource = require('@/assets/image/icon/ongoing.svg')
          break
        case 'NEW_RFQ_COMPLETED' :
        case 'NEW_CONTRACT_COMPLETED' :
          imageSource = require('@/assets/image/icon/new-success.svg')
          break
        case 'NEW_SHIPMENT_OTIF_COMPLETED' :
          imageSource = require('@/assets/image/icon/ms-complate-blue.svg')
          break
        case 'NEW_SHIPMENT_OTIF_DELIVERY' :
          imageSource = require('@/assets/image/icon/ms-deliv.svg')
          break
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_AIR' :
          imageSource = require('@/assets/image/icon/ms-airplane.svg')
          break
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_OCEAN' :
          imageSource = require('@/assets/image/icon/ms-ship.svg')
          break
        case 'NEW_SHIPMENT_OTIF_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_DESTINATION_LOCAL_HANDLING' :
          imageSource = require('@/assets/image/icon/ms-handling.svg')
          break
        case 'NEW_SHIPMENT_OTIF_PICKUP' :
          imageSource = require('@/assets/image/icon/ms-pickup.svg')
          break
        case 'NEW_SHIPMENT_OTIF_SCHEDULED' :
        case 'NEW_SHIPMENT_BOOKED' :
          imageSource = require('@/assets/image/icon/ms-schedule.svg')
          break
        case 'NEW_SHIPMENT_PRICE_CHANGE' :
          imageSource = require('@/assets/image/icon/price-changed.svg')
          break
        case 'NEW_DOCUMENT' :
        case 'NEW_DOCUMENT_RFQ' :
        case 'NEW_DOCUMENT_CONTRACT' :
        case 'NEW_DOCUMENT_SHIPMENT' :
          imageSource = require('@/assets/image/icon/dashboard-document.svg')
          break
        default : imageSource = ''
      }
      return imageSource
    },
    getMessageType (data) {
      let type = ''
      switch (data.topic) {
        case 'NEW_MESSAGE' :
        case 'NEW_MESSAGE_SHIPMENT' :
        case 'NEW_MESSAGE_CONTRACT' :
        case 'NEW_MESSAGE_RFQ' :
          type = 'New Message'
          break
        case 'PAYMENT' :
          type = 'Payment'
          break
        case 'NEW_BID_RFQ' :
        case 'NEW_BID_CONTRACT' :
          type = `${data.type === 'RFQ' ? 'RFQ' : 'Contract'}`
          break
        case 'NEW_SHIPMENT_DELAY_DESTINATION_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_DELAY_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_DELAY_PICKUP' :
        case 'NEW_SHIPMENT_DELAY_DELIVERY' :
        case 'NEW_SHIPMENT_DELAY_DEPARTURE' :
        case 'NEW_SHIPMENT_DELAY_SCHEDULED' :
        case 'NEW_SHIPMENT_DELAY_ARRIVAL' :
          type = 'Delay'
          break
        case 'NEW_RFQ_VALIDATING_REJECTED' :
        case 'NEW_CONTRACT_VALIDATING_REJECTED' :
        case 'NEW_SHIPMENT_REJECTED' :
          type = 'Rejected'
          break
        case 'NEW_SHIPMENT_CANCELED' :
          type = 'Canceled'
          break
        case 'NEW_RFQ_VALIDATING' :
        case 'NEW_CONTRACT_VALIDATING' :
          type = `${data.type === 'RFQ' ? 'RFQ' : 'Contract'}`
          break
        case 'NEW_CONTRACT_ONGOING' :
          type = 'Contract'
          break
        case 'NEW_RFQ_COMPLETED' :
        case 'NEW_CONTRACT_COMPLETED' :
          type = `${data.type === 'RFQ' ? 'RFQ' : 'Contract'}`
          break
        case 'NEW_SHIPMENT_OTIF_COMPLETED' :
          type = 'Completed'
          break
        case 'NEW_SHIPMENT_OTIF_DELIVERY' :
          type = 'Delivery'
          break
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_AIR' :
          type = 'Arrival'
          break
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_OCEAN' :
          type = 'Departure'
          break
        case 'NEW_SHIPMENT_OTIF_ORIGIN_LOCAL_HANDLING' :
          type = 'Origin Local Handling'
          break
        case 'NEW_SHIPMENT_OTIF_DESTINATION_LOCAL_HANDLING' :
          type = 'Destination Local Handling'
          break
        case 'NEW_SHIPMENT_OTIF_PICKUP' :
          type = 'Pickup'
          break
        case 'NEW_SHIPMENT_BOOKED' :
          type = 'Booked'
          break
        case 'NEW_SHIPMENT_OTIF_SCHEDULED' :
          type = 'Scheduled'
          break
        case 'NEW_SHIPMENT_PRICE_CHANGE' :
          type = 'Price Changes'
          break
        case 'NEW_DOCUMENT' :
        case 'NEW_DOCUMENT_RFQ' :
        case 'NEW_DOCUMENT_CONTRACT' :
        case 'NEW_DOCUMENT_SHIPMENT' :
          type = 'Document Uploaded'
          break
        default : type = ''
      }
      return type
    },
    getMessage (data) {
      let message = ''
      switch (data.topic) {
        case 'NEW_MESSAGE' :
        case 'NEW_MESSAGE_SHIPMENT' :
        case 'NEW_MESSAGE_CONTRACT' :
        case 'NEW_MESSAGE_RFQ' :
          message = data.unread > 1 ? `${data.unread} messages waiting to be replied` : 'Waiting to be replied'
          break
        case 'PAYMENT' :
          message = 'Immediate payment needed. Thank you!'
          break
        case 'NEW_BID_RFQ' :
        case 'NEW_BID_CONTRACT' :
          message = `${data.countBid} biddings are ready to be accepted`
          break
        case 'NEW_SHIPMENT_DELAY_DESTINATION_LOCAL_HANDLING' :
          message = 'at Destination Local Handling'
          break
        case 'NEW_SHIPMENT_DELAY_ORIGIN_LOCAL_HANDLING' :
          message = 'at Origin Local Handling'
          break
        case 'NEW_SHIPMENT_DELAY_PICKUP' :
          message = 'at Pickup'
          break
        case 'NEW_SHIPMENT_DELAY_DELIVERY' :
          message = 'at Delivery'
          break
        case 'NEW_SHIPMENT_DELAY_DEPARTURE' :
          message = 'at Departure'
          break
        case 'NEW_SHIPMENT_DELAY_SCHEDULED' :
          message = 'at Scheduled'
          break
        case 'NEW_SHIPMENT_DELAY_ARRIVAL' :
          message = 'at Arrival'
          break
        case 'NEW_RFQ_VALIDATING_REJECTED' :
        case 'NEW_CONTRACT_VALIDATING_REJECTED' :
          message = `at ${data.type === 'RFQ' ? 'RFQ' : 'Contract'} Validating`
          break

        case 'NEW_SHIPMENT_REJECTED' :
          message = 'by Andalin'
          break
        case 'NEW_SHIPMENT_CANCELED' :
          message = 'due to your request'
          break
        case 'NEW_RFQ_VALIDATING' :
        case 'NEW_CONTRACT_VALIDATING' :
          message = 'Status updated to validating'
          break
        case 'NEW_CONTRACT_ONGOING' :
          message = 'Status updated to ongoing'
          break
        case 'NEW_RFQ_COMPLETED' :
        case 'NEW_CONTRACT_COMPLETED' :
          message = 'Status updated to completed'
          break
        case 'NEW_SHIPMENT_OTIF_COMPLETED' :
        case 'NEW_SHIPMENT_OTIF_DELIVERY' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_DESTINATION_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_PICKUP' :
        case 'NEW_SHIPMENT_BOOKED' :
        case 'NEW_SHIPMENT_OTIF_SCHEDULED' :
          message = 'Shipment status updated'
          break

        case 'NEW_SHIPMENT_PRICE_CHANGE' :
          message = `${data.type === 'SHIPMENT' ? 'Shipment' : data.type === 'RFQ' ? 'RFQ' : 'Contract'} new price has updated`
          break
        case 'NEW_DOCUMENT' :
        case 'NEW_DOCUMENT_RFQ' :
        case 'NEW_DOCUMENT_CONTRACT' :
        case 'NEW_DOCUMENT_SHIPMENT' :
          message = 'New Document From Admin'
          break
        default : message = ''
      }
      return message
    },
    getStatus (data) {
      let status = ''
      switch (data.topic) {
        case 'NEW_MESSAGE' :
        case 'NEW_MESSAGE_SHIPMENT' :
        case 'NEW_MESSAGE_CONTRACT' :
        case 'NEW_MESSAGE_RFQ' :
          status = 'Waiting to be replied'
          break
        case 'PAYMENT' :
          status = data.invoiceNumber
          break
        case 'NEW_BID_RFQ' :
        case 'NEW_BID_CONTRACT' :
          status = 'Quotation Available'
          break
        case 'NEW_SHIPMENT_DELAY_DESTINATION_LOCAL_HANDLING' :
          status = 'Destination Local Handling status updated'
          break
        case 'NEW_SHIPMENT_DELAY_ORIGIN_LOCAL_HANDLING' :
          status = 'Origin Local Handling status updated'
          break
        case 'NEW_SHIPMENT_DELAY_PICKUP' :
          status = 'Pick Up status updated'
          break
        case 'NEW_SHIPMENT_DELAY_DELIVERY' :
          status = 'Delivery status updated'
          break
        case 'NEW_SHIPMENT_DELAY_DEPARTURE' :
          status = 'Depature status update'
          break
        case 'NEW_SHIPMENT_DELAY_SCHEDULED' :
          status = 'Scheduled status update'
          break
        case 'NEW_SHIPMENT_DELAY_ARRIVAL' :
          status = 'Arrival status update'
          break
        case 'NEW_RFQ_VALIDATING_REJECTED' :
        case 'NEW_CONTRACT_VALIDATING_REJECTED' :
        case 'NEW_RFQ_VALIDATING' :
        case 'NEW_CONTRACT_VALIDATING' :
        case 'NEW_CONTRACT_ONGOING' :
        case 'NEW_RFQ_COMPLETED' :
        case 'NEW_CONTRACT_COMPLETED' :
          status = `${data.type === 'RFQ' ? 'RFQ' : 'Contract'} status updated`
          break
        case 'NEW_SHIPMENT_REJECTED' :
        case 'NEW_SHIPMENT_CANCELED' :
        case 'NEW_SHIPMENT_OTIF_COMPLETED' :
        case 'NEW_SHIPMENT_OTIF_DELIVERY' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_DESTINATION_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_PICKUP' :
        case 'NEW_SHIPMENT_OTIF_SCHEDULED' :
          status = 'Shipment status updated'
          break
        case 'NEW_SHIPMENT_BOOKED' :
          status = 'RFQ status has approved'
          break
        case 'NEW_SHIPMENT_PRICE_CHANGE' :
          status = `${data.type === 'SHIPMENT' ? 'Shipment' : data.type === 'RFQ' ? 'RFQ' : 'Contract'} new price has updated`
          break
        case 'NEW_DOCUMENT_RFQ' :
        case 'NEW_DOCUMENT_CONTRACT' :
        case 'NEW_DOCUMENT_SHIPMENT' :
          status = 'New Document From Admin'
          break
        default : status = ''
      }
      return status
    },
    getMessageDetail (data) {
      let message = ''
      switch (data.topic) {
        case 'NEW_MESSAGE' :
        case 'NEW_MESSAGE_SHIPMENT' :
        case 'NEW_MESSAGE_CONTRACT' :
        case 'NEW_MESSAGE_RFQ' :
          message = data.messageBody
          break
        case 'PAYMENT' :
          message = 'Immediate payment needed. Thank you!'
          break
        case 'NEW_BID_RFQ' :
        case 'NEW_BID_CONTRACT' :
          message = `${data.countBid > 0 ? data.countBid : ''} biddings are ready to be accepted`
          break
        case 'NEW_SHIPMENT_DELAY_DESTINATION_LOCAL_HANDLING' :
          message = 'This shipment has been delayed at Destination Local Handling'
          break
        case 'NEW_SHIPMENT_DELAY_ORIGIN_LOCAL_HANDLING' :
          message = 'This shipment has been delayed at Origin Local Handling'
          break
        case 'NEW_SHIPMENT_DELAY_PICKUP' :
          message = 'This shipment has been delayed at pick up process'
          break
        case 'NEW_SHIPMENT_DELAY_DELIVERY' :
          message = 'This shipment has been delayed at deliver process'
          break
        case 'NEW_SHIPMENT_DELAY_DEPARTURE' :
          message = 'This shipment has been delayed at origin port'
          break
        case 'NEW_SHIPMENT_DELAY_SCHEDULED' :
          message = 'This shipment has been delayed at scheduled process'
          break
        case 'NEW_SHIPMENT_DELAY_ARRIVAL' :
          message = 'This shipment has been delayed at destination port'
          break
        case 'NEW_RFQ_VALIDATING_REJECTED' :
        case 'NEW_CONTRACT_VALIDATING_REJECTED' :
          message = `This validating ${data.type === 'RFQ' ? 'RFQ' : 'contract'} stage has been rejected`
          break
        case 'NEW_RFQ_VALIDATING' :
        case 'NEW_CONTRACT_VALIDATING' :
          message = `This ${data.type === 'RFQ' ? 'RFQ' : 'contract'} status has moved to validating`
          break
        case 'NEW_CONTRACT_ONGOING' :
          message = 'This contract status is now on going'
          break
        case 'NEW_RFQ_COMPLETED' :
        case 'NEW_CONTRACT_COMPLETED' :
          message = `This ${data.type === 'RFQ' ? 'RFQ' : 'contract'} has been completed, congratulation !`
          break
        case 'NEW_SHIPMENT_REJECTED' :
          message = 'This shipment has rejected by Andalin'
          break
        case 'NEW_SHIPMENT_CANCELED' :
          message = 'This shipment has canceled due to your request'
          break
        case 'NEW_SHIPMENT_OTIF_COMPLETED' :
          message = 'Your shipment has completed, congratulation !'
          break
        case 'NEW_SHIPMENT_OTIF_DELIVERY' :
          message = 'This shipment has delivered by Andalin'
          break
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_AIR' :
          message = 'This shipment has arrived at destination port'
          break
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_OCEAN' :
          message = 'This shipment has arrived at origin port'
          break
        case 'NEW_SHIPMENT_OTIF_ORIGIN_LOCAL_HANDLING' :
          message = 'This shipment is being processed at Origin Customs Handling'
          break
        case 'NEW_SHIPMENT_OTIF_DESTINATION_LOCAL_HANDLING' :
          message = 'This shipment is being processed at Destination Customs Handling'
          break
        case 'NEW_SHIPMENT_OTIF_PICKUP' :
          message = 'This shipment has picked up by Andalin'
          break
        case 'NEW_SHIPMENT_BOOKED' :
          message = 'This RFQ has moved to Manage Shipment'
          break
        case 'NEW_SHIPMENT_OTIF_SCHEDULED' :
          message = 'This shipment has been scheduled by Andalin'
          break
        case 'NEW_SHIPMENT_PRICE_CHANGE' :
          message = 'This shipment price has change'
          break
        case 'NEW_DOCUMENT_RFQ' :
        case 'NEW_DOCUMENT_CONTRACT' :
        case 'NEW_DOCUMENT_SHIPMENT' :
          message = `There is new attachment at ${data.type === 'RFQ' ? 'RFQ' : data.type === 'CONTRACT' ? 'Contract' : 'Shipment'} details`
          break
        default : message = ''
      }
      return message
    },
    getRouterNameDashboard (data) {
      let route = ''
      switch (data.topic) {
        case 'NEW_MESSAGE_SHIPMENT' :
        case 'NEW_SHIPMENT_DELAY_DESTINATION_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_DELAY_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_DELAY_PICKUP' :
        case 'NEW_SHIPMENT_DELAY_DELIVERY' :
        case 'NEW_SHIPMENT_DELAY_DEPARTURE' :
        case 'NEW_SHIPMENT_DELAY_SCHEDULED' :
        case 'NEW_SHIPMENT_DELAY_ARRIVAL' :
        case 'NEW_SHIPMENT_REJECTED' :
        case 'NEW_SHIPMENT_CANCELED' :
        case 'NEW_SHIPMENT_OTIF_COMPLETED' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ARRIVAL_AIR' :
        case 'NEW_SHIPMENT_OTIF_DELIVERY' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_AIR' :
        case 'NEW_SHIPMENT_OTIF_DEPARTURE_OCEAN' :
        case 'NEW_SHIPMENT_OTIF_ORIGIN_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_DESTINATION_LOCAL_HANDLING' :
        case 'NEW_SHIPMENT_OTIF_PICKUP' :
        case 'NEW_SHIPMENT_BOOKED' :
        case 'NEW_SHIPMENT_OTIF_SCHEDULED' :
        case 'NEW_DOCUMENT_SHIPMENT' :
          route = {
            name: 'ManagementShipmentDetail',
            params: {
              id_shipment: data.referenceId || data.id,
              order_number: data.referenceNumber.split('/').join('-')
            }
          }
          break
        case 'NEW_MESSAGE_RFQ' :
        case 'NEW_BID_RFQ' :
        case 'NEW_RFQ_VALIDATING_REJECTED' :
        case 'NEW_RFQ_VALIDATING' :
        case 'NEW_RFQ_COMPLETED' :
          route = {
            name: 'RequestListStatusRFQ',
            params: {
              id_rfq: data.referenceId || data.id,
              rfqNumber: data.referenceNumber.split('/').join('-')
            }
          }
          break
        case 'NEW_MESSAGE_CONTRACT' :
        case 'NEW_BID_CONTRACT' :
        case 'NEW_CONTRACT_VALIDATING_REJECTED' :
        case 'NEW_CONTRACT_VALIDATING' :
        case 'NEW_CONTRACT_ONGOING' :
        case 'NEW_CONTRACT_COMPLETED' :
          route = {
            name: 'RequestListStatusContract',
            params: {
              id_contract: data.referenceId || data.id,
              contractNumber: data.referenceNumber.split('/').join('-')
            }
          }
          break
        case 'NEW_DOCUMENT_RFQ' :
        case 'NEW_DOCUMENT_CONTRACT' :
          route = {
            name: 'RequestListStatusContract',
            params: {
              id_contract: data.referenceId || data.id,
              contractNumber: data.referenceNumber.split('/').join('-'),
              type: 'group-chat'
            }
          }
          break
        default : route = ''
      }
      return route
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/dashboard/invoice_notif_todolist.js